import React from 'react';
import { PlaylistPlay } from "@mui/icons-material";
import styles from "../css/Audio.module.css";
import Button from "components/inputs/Button";
import { Switch } from "@mui/material";

const SubTopicAudioListDnd = ({ data, provided, handleOpenModal, deletedAudio }) => {
    return (
        <div className={styles.subAudioContainer}>
            <span {...provided.dragHandleProps} ><PlaylistPlay /></span>
            <img src={data.thumbnailUrl} alt={data.imageAltText} />
            <div className={styles.subAudioInfo}>
                <p>{data.title}</p>
                <span className={"ellipsis2"}>{data.script}</span>
                <audio controls={true} src={data.audioUrl} />
            </div>
            <div className={styles.subAudioBtnContainer} >
                <div className={"invalidNotice"}>
                    <span className={`invalidCircle ${data.invalid === false ? 'invalid' : ''}`} />
                    {data.invalid === false ? '활성화' : '비활성화'}
                </div>
                {/*<Switch sx={{ marginLeft: "auto" }} checked={data.invalid === false || data.invalid === "false"} disabled />*/}
                <div>
                    <Button onClick={handleOpenModal} style={{ background: "#DFA78F" }}>수정</Button>
                    <Button onClick={() => {deletedAudio(data.id)}} style={{ background: "#D55240", marginLeft: "0.2rem" }}>삭제</Button>
                </div>
            </div>
        </div>
    );
};

export default SubTopicAudioListDnd;